import Swiper from "swiper";
import {Navigation, Pagination} from 'swiper/modules';

export function productSliderInit() {

    const productSliderEl = document.querySelector('.swiper-container');
    if (!productSliderEl) {
        return;
    }
    const productSlider = new Swiper('.swiper-container', {
        modules: [Navigation, Pagination],

        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerGroupAuto: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            }
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesPerGroup: 2
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3
            },
            1250: {
                slidesPerView: 4,
                spaceBetween: 30,
                slidesPerGroup: 4
            }
        }
    });
}

export function allProductSliderInit() {
    const allProductSliderEl = document.querySelector('.swiper-container-all-products');
    if (!allProductSliderEl) {
        return;
    }
    const allProductSlider = new Swiper('.swiper-container-all-products', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 15,
        slidesPerGroupAuto: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            }
        },
    });
}

export default function initSliders() {
    productSliderInit();
    allProductSliderInit();
}